export enum TrackedEventCategory {
    LOGIN = 'Login',
    REGISTER = 'Register',
    MENU = 'Menu',
    PURCHASE_FLOW = 'Purchase Flow',
    JOURNEY_PLANNER = 'Journey Planner',
    EXPLORE = 'Explore',
    TICKETS = 'Tickets',
    DISTURBANCES = 'Disturbances',
    PROFILE = 'Profile'
}
